var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},[_c('div',[_vm._v("该功能已牵至产品管理-生成库存")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.gotos('zlgl_cpzl_cpgl')}}},[_vm._v("点击前往")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }